import { render, staticRenderFns } from "./UploadAuthorsWork.vue?vue&type=template&id=09f79fe9"
import script from "./UploadAuthorsWork.vue?vue&type=script&lang=js"
export * from "./UploadAuthorsWork.vue?vue&type=script&lang=js"
import style0 from "./UploadAuthorsWork.vue?vue&type=style&index=0&id=09f79fe9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports